import React, { Component } from "react";
import { currentLocale } from "../locale";
import { replace, compose } from "ramda";
import { connect } from "react-redux";
import { SET_VALID, SET_INVALID, NO_STICKY, GUID_SET } from "../constants";
import {
  isEmpty,
  find,
  propEq,
  isNil,
  and,
  or,
  toLower,
  propSatisfies,
  contains,
  includes
} from "ramda";
import { NotFound } from "./notFound";
import { today } from "../lib/checkAge";
import {
  Notification,
  AccessDeniedNotification,
  Progress
} from "../components/modal";
import { create_UUID } from "../lib/guid";
import { converter } from "../lib/converter";

const OT = require("@opentok/client");
class Step0 extends Component {
  state = {
    noAudio: false,
    noVideo: false,
    needsUpgrade: null,
    userAgent: null,
    allSet: null,
    stream: null
  };

  componentWillMount() {
    this.props.dispatch({ type: SET_INVALID, payload: false });
    //  }
    async function getMedia(props) {
      let stream = null;
      const constraints = { audio: true, video: true };
      try {
        sessionStorage.setItem("allSet", "pending");
        // this.props.dispatch({ type: SET_INVALID, payload: false })
        stream = await navigator.mediaDevices.getUserMedia(constraints);
        sessionStorage.setItem("allSet", true);
        // Stop the tracks associated with this stream.
        stream.getTracks().forEach(trk => trk.stop());
      } catch (err) {
        sessionStorage.setItem("allSet", false);
        //  props.dispatch({ type: SET_INVALID, payload: false })
      }
    }

    this.setState({ needsUpgrade: OT.checkSystemRequirements() });
    this.setState({ userAgent: window.navigator.userAgent });

    OT.getDevices((error, devices) => {
      if (
        find(propEq("kind", "videoInput"), devices) === undefined &&
        find(propEq("kind", "audioInput"), devices) === undefined
      ) {
        this.setState({ noAudio: true, noVideo: true });
        this.props.dispatch({ type: NO_STICKY, payload: true });
        this.props.dispatch({ type: SET_INVALID, payload: false });
        //  return;
      } else if (find(propEq("kind", "videoInput"), devices) === undefined) {
        this.setState({ noVideo: true });
        this.props.dispatch({ type: NO_STICKY, payload: true });
        this.props.dispatch({ type: SET_INVALID, payload: false });
        //  return;
      } else if (find(propEq("kind", "audioInput"), devices) === undefined) {
        if (process.env.NODE_ENV === "production") {
          this.setState({ noAudio: true });
          this.props.dispatch({ type: NO_STICKY, payload: true });
          this.props.dispatch({ type: SET_INVALID, payload: false });
          // return;
        } else {
          getMedia().then(() => {
            // this.setState({ allSet: localStorage.allSet.toString() })
            if (
              sessionStorage.allSet !== false &&
              sessionStorage.allSet !== "false"
            ) {
              this.setState({ accessDenied: false, allSet: true });
              this.props.dispatch({ type: SET_VALID, payload: true });
              const guid = create_UUID();
              if (isNil(this.props.signedWaiver.guid)) {
                this.props.dispatch({ type: GUID_SET, payload: guid });
              }
            } else {
              this.setState({ accessDenied: true, allSet: false });
              //   this.props.dispatch({ type: SET_INVALID, payload: false })
            }
          });
        }
        //else { return }
      } else {
        getMedia().then(() => {
          // this.setState({ allSet: localStorage.allSet.toString() })
          if (
            sessionStorage.allSet !== false &&
            sessionStorage.allSet !== "false"
          ) {
            this.setState({ accessDenied: false, allSet: true });
            this.props.dispatch({ type: SET_VALID, payload: true });
            const guid = create_UUID();
            if (isNil(this.props.signedWaiver.guid)) {
              this.props.dispatch({ type: GUID_SET, payload: guid });
            }
          } else {
            this.setState({ accessDenied: true, allSet: false });
            //   this.props.dispatch({ type: SET_INVALID, payload: false })
          }
        });
        // this.props.dispatch({ type: SET_VALID, payload: true });
      }
    });
  }

  render() {
    const { waiver } = this.props;
    const instruction1 = replace(
      "{{-Date-}}",
      today,
      `${currentLocale.txtInstructions1}`
    );
    const instruction2 = compose(
      replace("{{-CompanyName-}}", `${waiver.companyName}`),
      replace("{{-WaiverName-}}", `${waiver.name}`)
    )(`${currentLocale.txtInstructions3}`);
    return (
      <React.Fragment>
        {/* {or(propSatisfies(x => x === 404, "status", waiver), and(gt(waiver.waiverId, 0), and(isNil(waiver.participantPdf), isNil(waiver.guardianPdf)))) ? ( */}
        {waiver.loading ? (
          <progress className="progress is-large is-primary" max="100">
            60%
          </progress>
        ) : or(
          propSatisfies(x => x === 404, "status", waiver),
          and(isNil(waiver.participantPdf), isNil(waiver.guardianPdf))
        ) ? (
          //checks if waiver exists and if there is a pdf available
          <NotFound />
        ) : (
          <div>
            <React.Fragment>
              {this.state.needsUpgrade !== 1 &&
                contains("mac os", toLower(this.state.userAgent)) ? (
                <Notification>
                  <p className="subtitle has-text-centered">
                    {converter.convert(`${currentLocale.ios}`)}
                  </p>
                </Notification>
              ) : this.state.needsUpgrade !== 1 &&
                !contains("mac os", toLower(this.state.userAgent)) ? (
                <Notification>
                  <p className="subtitle has-text-centered">
                    {converter.convert(`${currentLocale.needsUpgrade}`)}
                  </p>
                </Notification>
              ) : this.state.noAudio && this.state.noVideo ? (
                <Notification>
                  <p className="subtitle has-text-centered">
                    {currentLocale.noVideoOrAudio}
                  </p>
                  <p className="has-text-centered">
                    {currentLocale.initialDeviceCheck}
                  </p>
                </Notification>
              ) : this.state.noVideo ? (
                <Notification>
                  <p className="subtitle has-text-centered">
                    {currentLocale.noVideo}
                  </p>
                  <p className="has-text-centered">
                    {currentLocale.initialDeviceCheck}
                  </p>
                </Notification>
              ) : this.state.noAudio ? (
                <Notification>
                  <p className="subtitle has-text-centered">
                    {currentLocale.noAudio}
                  </p>
                  <p className="has-text-centered">
                    {currentLocale.initialDeviceCheck}
                  </p>
                </Notification>
              ) : sessionStorage.allSet &&
                sessionStorage.allSet === "pending" ? (
                <Progress />
              ) : sessionStorage.allSet && sessionStorage.allSet === "false" ? (
                <AccessDeniedNotification open={!this.state.allSet} />
              ) : (
                <div />
              )}
            </React.Fragment>
            <div className="subtitle is-5">
              {converter.convert(instruction1)}
            </div>
            <br />
            <article className="message is-info">
              <div className="message-header">
                <h4>{waiver.name}</h4>
                <h6>{waiver.companyName} </h6>
              </div>
              <br />
              <div>
                {isEmpty(this.props.waiver.imageUrl) ? (
                  <div>
                    <p className="subtitle">{waiver.description}</p>
                  </div>
                ) : (
                  <article className="media columns">
                    <div className="column is-one-fifth">
                      <figure className=" image is-square">
                        <img src={waiver.imageUrl} alt={waiver.name} />
                      </figure>
                    </div>
                    <div className="column is-four-fifths">
                      <p className="subtitle is-5">{waiver.description}</p>
                    </div>
                  </article>
                )}
              </div>
            </article>

            <span className="subtitle is-centered">
              {converter.convert(instruction2)}
            </span>
            <article className="subtitle is-centered is-6 has-text-centered">
              {converter.convert(`${currentLocale.privacy}`)}
            </article>
            <br />
            <br />
            <br />
          </div>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({});
const mapActionToProps = dispatch => ({
  dispatch
});
export default connect(
  mapStateToProps,
  mapActionToProps
)(Step0);
